/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ParkRepresentation,
} from '../models/index';
import {
    ParkRepresentationFromJSON,
    ParkRepresentationToJSON,
} from '../models/index';

export interface GetGeneratorsForParkRequest {
    key: string;
}

/**
 * 
 */
export class ParksApi extends runtime.BaseAPI {

    /**
     * Get all the keys of all generators in the park
     * Get generators in park
     */
    async getGeneratorsForParkRaw(requestParameters: GetGeneratorsForParkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getGeneratorsForPark().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:read"]);
        }


        let urlPath = `/parks/{key}/generators`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all the keys of all generators in the park
     * Get generators in park
     */
    async getGeneratorsForPark(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getGeneratorsForParkRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Get all parks the current user has access to
     * Get parks
     */
    async getParksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParkRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:read"]);
        }


        let urlPath = `/parks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParkRepresentationFromJSON));
    }

    /**
     * Get all parks the current user has access to
     * Get parks
     */
    async getParks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParkRepresentation>> {
        const response = await this.getParksRaw(initOverrides);
        return await response.value();
    }

}
